import { IndianRupee } from 'lucide-react';

export default function SplashLoader() {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-stone-950 gap-6">
      {/* Logo mark with pulse ring */}
      <div className="relative">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center shadow-xl shadow-orange-500/30">
          <IndianRupee size={30} className="text-white" />
        </div>
        <div className="absolute inset-0 rounded-2xl bg-orange-500/20 animate-ping" />
      </div>

      {/* Brand name */}
      <p className="text-xl font-extrabold text-orange-500 tracking-tight">BudgetMantra</p>

      {/* Wave dots — ChatGPT-style */}
      <div className="flex items-end gap-1.5">
        {[0, 1, 2, 3, 4].map(i => (
          <div
            key={i}
            className="w-1.5 bg-orange-500 rounded-full"
            style={{
              animation: `wave 1.2s ease-in-out infinite`,
              animationDelay: `${i * 0.12}s`,
              height: '6px',
            }}
          />
        ))}
      </div>

      <style>{`
        @keyframes wave {
          0%, 60%, 100% { height: 6px; opacity: 0.4; }
          30% { height: 20px; opacity: 1; }
        }
      `}</style>
    </div>
  );
}
